import routerProvider, {
    checkAuthentication,
    handleRefineParams,
    NextRouteComponent,
    Link,
} from "./pages";

export default routerProvider;

export { checkAuthentication, handleRefineParams, NextRouteComponent, Link };
